import { gql } from '@apollo/client';

export const UPDATE_PROJECT = gql`
  mutation UpdateProject($project: UpdateProjectInput!, $projectId: ID!, $vendorId: ID!) {
    updateProject(project: $project, projectId: $projectId, vendorId: $vendorId) {
      connected
      createdAt
      createdBy
      firstName
      id
      lastName
      mqttEndpoint
      name
      status
      type
      vendorProjectOwnerEmail
    }
  }
`;
